import React, { useContext } from 'react'
import { NotificationManagerContext, Text, View } from 'oio-react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import { useInitiativeList, useMe, useOrganization } from 'src/graphql/hooks'
import { ThreadUpdateGlyph24Icon } from 'assets/icons'
import AnnouncementBanner from 'src/custom/gns3/AnnouncementBanner'
import InboxListItem from '~/Messages/components/InboxListItem'
import InvitationListItem from '~/Messages/components/InvitationListItem'

const MessagesInbox = () => {
   const { showNotification } = useContext(NotificationManagerContext)
   const { organization } = useOrganization()
   const { me, refetch } = useMe()
   const { initiativeList: initiativeListWithUnreadMessages } = useInitiativeList({
      userRelationshipFilter: {
         userId: 'me',
         hasUnreadMessages: true
      }
   })

   const numTotalNotifications = me?.invitations.length +
      initiativeListWithUnreadMessages.items.length

   return (
      <View float="left" width="100%">
         <Helmet title={`Inbox | ${organization.name}`} />
         <View paddingBottom="20px[a] 30px[b] 40px[c-f]">
            <Text
               size="7"
               weight="medium"
               color="#000"
               letterSpacing="-0.5px">
               Inbox
            </Text>
         </View>
         {/* TODO: Get this abomination out of here
         This is a temporary solution to silence MB for the time being
         See PR #518 */}
         {organization.slug === 'gns3' && <AnnouncementBanner />}
         {numTotalNotifications === 0 && (
            <View
               width="100%"
               padding="60px"
               textAlign="center"
               borderTop="1px solid #eee">
               <Text size="2" color="#aaa">
                  Your inbox is currently empty
               </Text>
            </View>
         )}
         {me.invitations.map((relationship) => {
            const invitedRoleParticipantElements = relationship.elements.filter(element => (
               element.__typename === 'RelationshipElementRoleParticipant' &&
               element.status === 'invited'
            ))

            return invitedRoleParticipantElements.map(element => (
               <InvitationListItem
                  key={element.id}
                  onAccept={() => {
                     refetch()
                     showNotification({
                        message: 'Thank you for accepting this invitation',
                        title: 'Success!',
                        type: 'success'
                     })
                  }}
                  onDecline={refetch}
                  relationship={relationship}
                  roleParticipantElement={element}
               />
            ))
         })}
         {/* This is currently designed with the assumption that notifications are related
         to thread updates only
         See PR #394 */}
         {initiativeListWithUnreadMessages.items.map(initiative => (
            <InboxListItem
               key={initiative.id}
               date={initiative.thread.lastEntryDate}
               description={(
                  <>
                     {initiative.addedBy.id === me.id
                        ? `Your ${initiative.type.nameSingular}: `
                        : `The ${initiative.type.nameSingular} you are following: `
                     }
                     <Link
                        to={`/initiatives/${initiative.slug}`}
                        style={{ fontWeight: '500', color: '#444' }}>
                        {initiative.name}
                     </Link>
                     {' has new comments'}
                  </>
               )}
               icon={<ThreadUpdateGlyph24Icon width="18px" height="18px" color="#fff" />}
               iconBackgroundColor="#45abff"
            />
         ))}
      </View>
   )
}

export default MessagesInbox
